import BaseAPI from "../api";

const path: string = "notifications";

export interface notificationType {
  page?: number;
  limit?: number;
  keyword?: string;
  statusCode?: string;
  idFiscalYear?: number;
  endDate?: string;
  startDate?: string;
}

export class NotificationApi extends BaseAPI {
  static getNotification(props: notificationType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  static deleteNotification(idNotification: number): Promise<any> {
    return this.api
      .patch(`${path}/${idNotification}/delete`)
      .then((res) => res);
  }
  static countNotification():Promise<any>{
    return this.api.get(`${path}/count`).then(res => res);
  }
}
